import {  useState } from 'react'
import LoadingScreen from 'components/loading-screen'
import { Question, SurveyResponse } from 'contexts/survey-context/survey.interface'
import StepOne from './steps/one'
import StepTwo from './steps/two'
import StepThree from './steps/three'

interface IProps {
  redirect: () => void
  title: string,
  id: number,
  questions: Question[];
  handleSubmit: (callback: () => Promise<void>) => void
  updatePolarisSurvey?: (select: SurveyResponse[][], id: number) => Promise<void>
}

const PostalCode = ({ questions, id, handleSubmit, updatePolarisSurvey }: IProps) => {
  const [info, setInfo] = useState({
    postalCode: '',
    neighborhoodId: null,
    state: '',
    colonia: '', // cologne?
    municipality: '',
    corrienteUrbana: null
  })

  const [step, setStep] = useState(1)

  const [answers, setAnswers] = useState([])

  const changeStep = (count: string = '') => {
    const newStep = count === 'increment' ? step + 1 : step - 1;
    setStep(newStep);
  }

  switch (step) {
  case 1:
    return <div className="w-full"><StepOne title={'nómina TU código postal'} setInfo={setInfo} info={info} changeStep={changeStep} answers={answers} question={questions[0]} /></div>;
  case 2:
    return <div className="w-full"><StepTwo id={id} title={'Elige tu corriente urbana'} setInfo={setInfo} info={info} changeStep={changeStep} answers={answers} question={questions[1]} setAnswers={setAnswers} handleSubmit={handleSubmit} updatePolarisSurvey={updatePolarisSurvey} /></div>;
  case 3:
    return <div className="w-full"><StepThree /></div>;
  default:
    return <LoadingScreen />;
  }
}

export default PostalCode